import { render, staticRenderFns } from "./realNameAuthentication.vue?vue&type=template&id=5a9e9354"
import script from "./realNameAuthentication.vue?vue&type=script&lang=js"
export * from "./realNameAuthentication.vue?vue&type=script&lang=js"
import style0 from "./realNameAuthentication.vue?vue&type=style&index=0&id=5a9e9354&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports